import React from 'react';
import { Box, Typography } from '@mui/material';
import { fmtWinRate, winRateContext } from '../utils/winRate';

/**
 * Win rate with its closed n and open share on a secondary line.
 * `rate` null renders an em dash (nothing closed), never 0.0%.
 */
export default function WinRateWithOpen({
  rate, n, openShare, variant = 'body2', inline = false, align, sx, label,
}) {
  const ctx = winRateContext({ n, openShare });
  return (
    <Box component={inline ? 'span' : 'div'} sx={{ display: inline ? 'inline-block' : 'block', textAlign: align, ...sx }}>
      <Typography component="span" variant={variant} sx={{ fontWeight: 600 }}>
        {fmtWinRate(rate)}
      </Typography>
      {label && <Typography component="span" variant="caption" color="text.secondary"> {label}</Typography>}
      {ctx && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
          {ctx}
        </Typography>
      )}
    </Box>
  );
}
